module.exports = __webpack_public_path__ + "static/img/共享专用运维车.a9e6b7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/共享专用运维车.jpg
// module id = OK4T
// module chunks = 1